import { __rest } from "tslib";
import React from 'react';
import { Button as MuiButton } from '@material-ui/core';
import { RakutenIcon } from '@next-common/material-ui-icons';
import { withColorTheme } from '../withColorTheme';
export const RawButton = (props) => {
    // eslint-disable-next-line react/prop-types
    const { startIcon, endIcon, children } = props, otherProps = __rest(props, ["startIcon", "endIcon", "children"]);
    return (React.createElement(MuiButton, Object.assign({ startIcon: typeof startIcon === 'string' ? React.createElement(RakutenIcon, { icon: startIcon }) : startIcon, endIcon: typeof endIcon === 'string' ? React.createElement(RakutenIcon, { icon: endIcon }) : endIcon, "data-qa": "button-core", "data-role": "none" }, otherProps), children));
};
export const Button = withColorTheme(RawButton);
